import { render, staticRenderFns } from "./ChangeApproval.vue?vue&type=template&id=60cfc8b5&scoped=true"
import script from "./ChangeApproval.vue?vue&type=script&lang=js"
export * from "./ChangeApproval.vue?vue&type=script&lang=js"
import style0 from "./ChangeApproval.vue?vue&type=style&index=0&id=60cfc8b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cfc8b5",
  null
  
)

export default component.exports